var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeparate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C11.5833 7 11.2292 6.85417 10.9375 6.5625C10.6458 6.27083 10.5 5.91667 10.5 5.5C10.5 5.08333 10.6458 4.72917 10.9375 4.4375C11.2292 4.14583 11.5833 4 12 4C12.4167 4 12.7708 4.14583 13.0625 4.4375C13.3542 4.72917 13.5 5.08333 13.5 5.5C13.5 5.91667 13.3542 6.27083 13.0625 6.5625C12.7708 6.85417 12.4167 7 12 7ZM12 20C11.5833 20 11.2292 19.8542 10.9375 19.5625C10.6458 19.2708 10.5 18.9167 10.5 18.5C10.5 18.0833 10.6458 17.7292 10.9375 17.4375C11.2292 17.1458 11.5833 17 12 17C12.4167 17 12.7708 17.1458 13.0625 17.4375C13.3542 17.7292 13.5 18.0833 13.5 18.5C13.5 18.9167 13.3542 19.2708 13.0625 19.5625C12.7708 19.8542 12.4167 20 12 20Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparate);
export default __webpack_public_path__ + "static/media/Separate.876880b87560ab8a9d557d08c0a76132.svg";
export { ForwardRef as ReactComponent };